import React from 'react';
import GlassCard from './GlassCard';
import { BsCalendar } from 'react-icons/bs';
import { MdLocationOn } from 'react-icons/md';

function ExperienceCard({ experience }) {
  return (
    <GlassCard className="experience-card">
      <div className="experience-header">
        <div className="experience-company">
          {experience.logo && (
            <img src={experience.logo} alt={`${experience.company} Logo`} className="company-logo" />
          )}
          <div>
            <h3 className="company-name">{experience.company}</h3>
            <p className="position-title">{experience.position}</p>
          </div>
        </div>
        <div className="experience-meta">
          <span className="experience-date">
            <BsCalendar /> {experience.date}
          </span>
          {experience.location && (
            <span className="experience-location">
              <MdLocationOn /> {experience.location}
            </span>
          )}
        </div>
      </div>
      <div className="experience-content">
        {Array.isArray(experience.description) ? (
          <ul className="experience-list">
            {experience.description.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        ) : (
          <p>{experience.description}</p>
        )}
      </div>
    </GlassCard>
  );
}

export default ExperienceCard;
